import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { Config } from '@app/shared/utils/config/config.model';

fetch(`./assets/config/json/config.json`)
	.then((response) => response.json())
	.then((config: Config) => {
		if (config.production) {
			enableProdMode();
		}

		platformBrowserDynamic()
			.bootstrapModule(AppModule)
			.catch((err) => console.error(err));
	})
	.catch((error) => {
		console.error('Error while fetching config.json', error);
	});
